import axios from '@/libs/axios'

const endpoint = 'request-letters'

const appendArray = (formData, key, values = []) => {
  values.forEach(value => {
    formData.append(key, value)
  })
}

const toFormData = data => {
  const formData = new FormData()
  formData.append('title', data.title)
  formData.append('body', data.body)
  appendArray(formData, 'apply_docs', data.apply_docs || [])
  if (data.attachment_file instanceof File) {
    formData.append('attachment_file', data.attachment_file)
  }
  return formData
}

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results || response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const get = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/`)
    .then(response => {
      commit('GET', response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const create = (_, data) => axios.post(`/${endpoint}/`, toFormData(data))

const update = (_, data) => axios.patch(`/${endpoint}/${data.id}/`, toFormData(data))

const del = (_, data) => axios.delete(`/${endpoint}/${data.id}/`)

const send = (_, id) => axios.post(`/${endpoint}/${id}/send/`, {})

const review = (_, data) => axios.post(`/${endpoint}/${data.id}/review/`, {
  status: data.status,
  comment: data.comment,
})

const orgStudents = (_, queryParams) => axios.get('/apply-document/org_students/', { params: queryParams })

export default {
  list,
  get,
  create,
  update,
  del,
  send,
  review,
  orgStudents,
}
